module.exports = __webpack_public_path__ + "static/Mountain3-56a8b847fc272d3586633e73f02de862.png";